
<template>
  <BasicTable
    v-loading="loading"
    :config="config"
    :data="data"
  >
    <template #withdrawOrDepositAmountHeader>
      <Row>
        <span>{{ $t('trade.amount2') }}(USDT)</span>
        <el-popover
          placement="top"
          popper-class="-m-"
          :width="120"
          trigger="hover"
          :content="$t('home.title5')"
        >
          <template #reference>
            <IconSvg class="font-11 m-l-5 m-b-1 pointer" name="icon-a-zu13873" />
          </template>
        </el-popover>
      </Row>
    </template>
  </BasicTable>

</template>

<script setup>
const props = defineProps({
  tabTimeValue: {
    default: []
  },
})

// const isDepositOptions = [
//   {
//     label: '是',
//     value: 0,
//   },
//   {
//     label: '否',
//     value: 1,
//   }
// ]

// const isTradeOptions = [
//   {
//     label: '是',
//     value: 0,
//   },
//   {
//     label: '否',
//     value: 1,
//   }
// ]

let loading = $ref(false)
let data = $ref([])
const getData = async () => {
  try {
    loading = true
    const body = {}
    if (!isEmpty(props.tabTimeValue)) {
      body.startTime = props.tabTimeValue[0]
      body.endTime = props.tabTimeValue[1]
    }
    const d = await dataApi.firstWithdraw(body)

    data = d
  } finally {
    loading = false
  }
}

// 表格配置
const config = $computed(() => {
  return [
    { label: 'uid', prop: 'uid', minWidth: 100 },
    // { label: '入金时间', prop: 'createTime', type: 'time', width: 172, align: 'right' },
    { label: $t('home.depositTime'), prop: 'date' },
    { label: $t('trade.amount2'), prop: 'withdrawOrDepositAmount', type: 'num' },
  ]
})

onBeforeMount(async () => {
  getData()
})

watch(() => props.tabTimeValue, () => {
  getData()
})
</script>

<style lang="scss">
</style>
